export const truncateLongNames = (name, limit, withSpaces) => {
  const nameArr = withSpaces ? name.split(' ') : [name]
  return nameArr
    .map(thisName => {
      if (!limit || thisName.length < limit) {
        return thisName
      }

      return APRICOT.CBUtils.textTruncate(thisName, limit, 'last', '...')
    })
    .join(' ')
}

export const isEmpty = val => {
  let result
  // return Array.isArray(val) ? !val.length :
  //   typeof val === "string" ? !val.trim().length :
  //     typeof val === "object" ? !Object.keys(val).length :
  //       typeof val === "boolean" || (typeof val === "number" && val > -1) ? false :
  //         true
  if (val === null || val === undefined) {
    result = true
  } else {
    // Array
    if (Array.isArray(val)) {
      result = !val.length
      // String
    } else if (typeof val === 'string') {
      result = !val.trim().length
      // Object
    } else if (typeof val === 'object') {
      result = !Object.keys(val).length
      // Boolean
    } else if (typeof val === 'boolean' || (typeof val === 'number' && val > -1)) {
      result = false
    } else {
      result = true
    }
  }

  return result
}

export const queryParamsToObj = search => {
  const searchString = search.startsWith('?') ? search.substr(1) : search
  return searchString.split('&').reduce((obj, str) => {
    const [key, value] = str.split('=')
    let existing = obj[key]

    if (existing) {
      existing = Array.isArray(existing) ? existing : [existing]
      return { ...obj, [key]: [...existing, value] }
    }

    return { ...obj, [key]: value }
  }, {})
}

// https://codeburst.io/throttling-and-debouncing-in-javascript-646d076d0a44
export const debounced = (delay, fn) => {
  let timerId
  return function (...args) {
    if (timerId) {
      clearTimeout(timerId)
    }
    timerId = setTimeout(() => {
      fn(...args)
      timerId = null
    }, delay)
  }
}

export const getRandomInt = max => Math.floor(Math.random() * max)

// https://stackoverflow.com/questions/6248666/how-to-generate-short-uid-like-ax4j9z-in-js
export const generateShortUID = () => {
  let firstPart = (Math.random() * 46656) | 0
  let secondPart = (Math.random() * 46656) | 0
  firstPart = ('000' + firstPart.toString(36)).slice(-3)
  secondPart = ('000' + secondPart.toString(36)).slice(-3)
  return firstPart + secondPart
}

export const convertTitleCase = stringToProcess => {
  const lowercaseString = stringToProcess.toLowerCase()
  const uppercaseFirstChar = lowercaseString.charAt(0).toUpperCase()
  return `${uppercaseFirstChar}${lowercaseString.slice(1)}`
}
